const state = {
  activeMenu: "/"
};

const mutations = {
  MSetMenu(state, menu) {
    state.activeMenu = menu
  }
};

const actions = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
